export const sampleApiResponse = {
    // ------ mock data
    // "statusCode": 200,
    // "customCode": 1000,
    // "message": "OK",
    // "data": {
    //     "totalPayout": 12500.0,
    //     "paidPayout": 10000.0,
    //     "payoutHistory": [
    //         {
    //             "paidAmount": 1250.0,
    //             "payoutStatus": "SUCCESS",
    //             "createdAt": "2025-06-05T17:33:28",
    //             "updatedAt": "2025-06-05T17:33:28",
    //             "payoutMode": "UPI",
    //             "payoutOrderId": "987654321012",
    //             "createdBy": "f7b6edc3-8ac9-48cf-a35d-ce194309d0a6"
    //         },
    //         {
    //             "paidAmount": 123850.0,
    //             "payoutStatus": "SUCCESS",
    //             "createdAt": "2025-06-05T10:45:00",
    //             "updatedAt": "2025-06-05T10:45:00",
    //             "payoutMode": "NEFT",
    //             "payoutOrderId": "987654321013",
    //             "createdBy": "f7b6edc3-8ac9-48cf-a35d-ce194309d0a6"
    //         },
    //         {
    //             "paidAmount": 2100.0,
    //             "payoutStatus": "PENDING",
    //             "createdAt": "2025-06-04T14:15:00",
    //             "updatedAt": "2025-06-04T14:15:00",
    //             "payoutMode": "BANK_TRANSFER",
    //             "payoutOrderId": "987654321014",
    //             "createdBy": "f7b6edc3-8ac9-48cf-a35d-ce194309d0a6"
    //         },
    //         {
    //             "paidAmount": 1250000.0,
    //             "payoutStatus": "SUCCESS",
    //             "createdAt": "2025-05-15T12:34:00",
    //             "updatedAt": "2025-06-03T11:20:00",
    //             "payoutMode": "NEFT",
    //             "payoutOrderId": "987654321012",
    //             "createdBy": "f7b6edc3-8ac9-48cf-a35d-ce194309d0a6"
    //         },
    //     ]
    // }
};

// Utility function to format date
export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2); // Get last 2 digits
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;

    return `${day} ${month} '${year}, ${displayHours}:${minutes} ${ampm}`;
};

// Utility function to format amount in Indian format
export const formatAmount = (amount) => {
    return `Rs. ${amount.toLocaleString('en-IN')}`;
};

// Utility function to format status
export const formatStatus = (status) => {
    // const statusMap = {
    //     'SUCCESS': 'Success',
    //     'PENDING': 'Pending',
    //     'FAILED': 'Failed',
    //     'COMPLETED': 'Success'
    // };
    // return statusMap[status] || status;
    return "Success"
};

// Utility function to format pay mode
export const formatPayMode = (mode) => {
    const modeMap = {
        'UPI': 'UPI',
        'BANK_TRANSFER': 'BANK TRANSFER',
        'NEFT': 'NEFT',
        'WALLET': 'WALLET'
    };
    return modeMap[mode] || 'N/A';
};

// Function to transform API response to table format
export const transformApiDataToTableFormat = (apiResponse) => {
    if (!apiResponse?.data?.payoutHistory) {
        return [];
    }

    return apiResponse.data.payoutHistory.map(item => ({
        transactionId: item.payoutOrderId,
        payoutDate: formatDate(item.createdAt),
        payMode: formatPayMode(item.payoutMode),
        status: formatStatus(item.payoutStatus),
        amountPaid: formatAmount(item.paidAmount)
    }));
};

// Static data for fallback (keeping the existing format)
export const transactionData = transformApiDataToTableFormat(sampleApiResponse);

// You can also export functions to manipulate the data
export const getTransactionById = (id) => {
    return transactionData.find(transaction => transaction.transactionId === id);
};

export const getTransactionsByStatus = (status) => {
    return transactionData.filter(transaction => transaction.status === status);
};